import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scalePipe'
})
export class ScalePipePipe implements PipeTransform {

  transform(value: any, arg: String, se:any): unknown {
    let response = [];
    for (let i in value){
      if (arg!='Clínicas'&&arg!='Lingoes'){
        if (value[i].type==arg) {
          value[i].scale = i;
          if (arg!='Suplementarias') response.push(value[i]);
          else{
            if (se=='cg'&&(i=='A'||i=='R'||i=='Es'||i=='Do'||i=='Re')) response.push(value[i]);
            if (se=='me'&&(i=='MT'||i=='PK'||i=='MDS'||i=='PS')) response.push(value[i]);
            if (se=='dc'&&(i=='O-H'||i=='Mac-R'||i=='AAS'||i=='APS')) response.push(value[i]);
            if (se=='rg'&&(i=='GM'||i=='GF')) response.push(value[i]);

            if (se=='cg'&&(value[i].title.indexOf('A ')==0||value[i].title.indexOf('R ')==0||value[i].title.indexOf('Es ')==0||value[i].title.indexOf('Do')==0||value[i].title.indexOf('Re ')==0)) response.push(value[i]);
            if (se=='me'&&(value[i].title.indexOf('MT')==0||value[i].title.indexOf('PK')==0||value[i].title.indexOf('MDS')==0||value[i].title.indexOf('PS')==0)) response.push(value[i]);
            if (se=='dc'&&(value[i].title.indexOf('O-H')==0||value[i].title.indexOf('Mac-R')==0||value[i].title.indexOf('AAS')==0||value[i].title.indexOf('APS')==0)) response.push(value[i]);
            if (se=='rg'&&(value[i].title.indexOf('GM')==0||value[i].title.indexOf('GF')==0)) response.push(value[i]);
          }
        }
      }
      if (arg=='Clínicas'){
        if (i=='Hs'||i=='D'||i=='Hy'||i=='Pd'||i=='Mf'||i=='Pa'||i=='Pt'||i=='Sc'||i=='Ma'||i=='Si'||value[i].title.indexOf('Hs ')==0||value[i].title.indexOf('D ')==0||value[i].title.indexOf('Hy ')==0||value[i].title.indexOf('Pd ')==0||value[i].title.indexOf('Mf ')==0||value[i].title.indexOf('Pa ')==0||value[i].title.indexOf('Pt ')==0||value[i].title.indexOf('Sc ')==0||value[i].title.indexOf('Ma ')==0||value[i].title.indexOf('Si ')==0){
          value[i].scale = i;
          response.push(value[i])
        }
      }
      if (arg=='Lingoes'){
        if (value[i].type=='Clínicas'&&i!='Hs'&&i!='D'&&i!='Hy'&&i!='Pd'&&i!='Mf'&&i!='MfM'&&i!='Pa'&&i!='Pt'&&i!='Sc'&&i!='Ma'&&i!='Si'&&i!='L'&&i!='?'&&i!='F'&&i!='K'&&i!='FB'&&i!='F(P)'&&i!='VRIN'&&i!='TRIN'){
          value[i].scale = i;
          if (i.indexOf(se)==0||(value[i].title.indexOf(se)==0&&value[i].title!='D - Depresión'&&value[i].title!='Discordia familiar')) {
            response.push(value[i])
          }
        }
      }
    }
    return response;
  }
}
